import photoUploadConfig from 'modules/photo/config/photoUploadConfig.js'
export default {
  namespaced: true,
  state: {
    userAllowType: [
      'default',
      'html',
      'mail',
      'page',
      'banner',
      'product',
      'etc',
    ],
    pager: null,
    photos: [],
    type: null,
    lockType: null,
    page: 1,
    createdAt: null,
    selected: [],
    indexLoading: false,
    uploadLoading: false,
    photoUploadConfig,
    selector: false,
    selectLimit: 0,
  },
  mutations: {
    init(state) {
      state.pager = null
      state.photos = []
    },
    indexLoading(state, data = true) {
      state.indexLoading = data
    },
    uploadLoading(state, data = true) {
      state.uploadLoading = data
    },
    setResult(state, result) {
      state.pager = result.pager
      state.photos = result.data
    },
    setType(state, type) {
      state.type = type
      state.page = 1
    },
    setLockType(state, type) {
      state.type = type
      state.lockType = type
      state.page = 1
    },
    set(state, data) {
      state[data.key] = data.value
    },
    toggleSelected(state, id) {
      const hasSelected = state.selected.includes(id)
      if(!hasSelected) {
        state.selected.push(id)
      }

      else {
        const index = state.selected.indexOf(id)
        state.selected.splice(index, 1)
      }
    },
    toggleSelectedAll(state) {
      const all = _cloneDeep(state.photos).map(photo => photo.id)
      const isSelectedAll = _isEqual(state.selected, all)

      if(isSelectedAll) {
        state.selected = []
      }

      else {
        state.selected = all
      }
    },
    cleanSelected(state) {
      state.selected = []
    },
  },
  actions: {
    init(context, result) {
      context.commit('init', result)
    },
    indexLoading(context, data) {
      context.commit('indexLoading', data)
    },
    uploadLoading(context, data) {
      context.commit('uploadLoading', data)
    },
    setResult(context, result) {
      context.commit('setResult', result)
    },
    setType(context, type) {
      context.commit('setType', type)
    },
    setLockType(context, type) {
      context.commit('setLockType', type)
    },
    set(context, data) {
      context.commit('set', data)
    },
    toggleSelected(context, data) {
      context.commit('toggleSelected', data)
    },
    toggleSelectedAll(context) {
      context.commit('toggleSelectedAll')
    },
    cleanSelected(context) {
      context.commit('cleanSelected')
    },
  },
  getters: {
    page: state => state.page,
    pager: state => state.pager,
    photos: state => state.photos,
    quantity: state => state.photos.length,
    type: state => state.type,
    lockType: state => state.lockType,
    createdAt: state => state.createdAt,
    selected: state => state.selected,
    userAllowType: state => state.userAllowType,
    isSelectedAll: state => {
      const all = _cloneDeep(state.photos).map(photo => photo.id)
      if(state.selected.length == 0) return false
      return _isEqual(state.selected, all)
    },
    indexLoading: state => state.indexLoading,
    uploadLoading: state => state.uploadLoading,
    photoUploadConfig: state => state.photoUploadConfig,
    selector: state => state.selector,
    selectLimit: state => state.selectLimit,
  },
}